<template>
<div class="preview-container">
  <div id="datas" v-if="neweditForm" style="width: 100%;margin: 0 auto;display: flex;justify-content: center">
    <div id="baseData" style="width: 1050px;">
      <div class="base-data">
        <div class="base-title">
          <span>{{ neweditForm.name }}</span>
          <span class="m-l-20">高考志愿填报档案表</span>
        </div>

        <div class="base-table">
          <div class="base-tr title-th"><div class="txt-l">基本信息</div></div>
          <div class="base-tr-other">
            <div>学生姓名</div>
            <div>{{ neweditForm.name }}</div>
            <div>科类</div>
            <div>{{ neweditForm.major | filterMajor }}</div>
            <div>性别</div>
            <div>{{ neweditForm.sex == 0 ? '男' : '女' }}</div>
            <div>年龄</div>
            <div>{{ neweditForm.age }}</div>
            <div>出生日期</div>
            <div>{{ neweditForm.birthdayDate }}</div>
          </div>
          <div class="base-tr-other">
            <div>政治面貌</div>
            <div>{{ neweditForm.politic }}</div>
            <div>民族</div>
            <div>{{ neweditForm.nation }}</div>
            <div>考生类别</div>
            <div>{{ neweditForm.stuType }}</div>
            <div>外语语种</div>
            <div>{{ neweditForm.languagesMsg }}</div>
            <div>高考年份</div>
            <div>{{ neweditForm.other }}</div>
          </div>
          <div class="base-tr-other">
            <div style="width: 10%">身高(cm)</div>
            <div style="width: 10%">{{ neweditForm.height }}</div>
            <div style="width: 10%">体重(kg)</div>
            <div style="width: 10%">{{ neweditForm.weight }}</div>
            <div style="width: 10%">视力</div>
            <div style="width: 50%">{{ neweditForm.vision }}</div>
          </div>
          <div class="base-tr-other">
            <div style="width: 10%">其他情况</div>
            <div style="width: 40%">{{ neweditForm.others }}</div>
            <div style="width: 10%">体检结论</div>
            <div style="width: 40%">
              <span v-for="(item, index) in chooseMedical">{{item}}<span v-if="index != (chooseMedical.length - 1)">，</span></span>
            </div>
          </div>
          <div class="base-tr-other">
            <div style="width: 10%">就读学校</div>
            <div style="width: 40%">{{ neweditForm.school }}</div>
            <div style="width: 10%">户籍地址</div>
            <div style="width: 40%">{{ neweditForm.address }}</div>
          </div>
          <div class="base-tr-other" v-for="(item, index) in neweditForm.stuContacts">
            <div class="w-10">{{index == 0 ? '主联系人' : '次联系人'}}</div>
            <div class="w-10">{{ item.name }}</div>
            <div class="w-10">身份</div>
            <div class="w-10">{{ item.relationship }}</div>
            <div class="w-10">职业</div>
            <div class="w-20">{{ item.occupation }}</div>
            <div class="w-10">电话</div>
            <div class="w-20">{{ item.phone }}</div>
          </div>
          <div class="base-tr title-th"><div class="txt-l">考试成绩</div></div>
          <div class="base-tr score-tr">
            <div class="flex-2">考试名称</div>
            <div class="flex-8">
              <div>语文</div>
              <div>数学</div>
              <div>外语</div>
              <div>物理</div>
              <div>化学</div>
              <div>生物</div>
              <div>综合</div>
              <div>总分</div>
              <div>位次</div>
              <div>口试</div>
              <div>备注</div>
            </div>
          </div>
          <div class="base-tr score-tr" v-for="(item, index) in neweditForm.stuAchievements">
            <div class="flex-2">{{item.examName}}</div>
            <div class="flex-8">
              <div>{{item.language ? item.language : '/'}}</div>
              <div>{{item.mathematics ? item.mathematics : '/'}}</div>
              <div>{{item.foreignLanguages ? item.foreignLanguages : '/'}}</div>
              <div>{{item.physics ? item.physics : '/'}}</div>
              <div>{{item.chemistry ? item.chemistry : '/'}}</div>
              <div>{{item.biology ? item.biology : '/'}}</div>
              <div>{{item.comprehensive ? item.comprehensive : '/'}}</div>
              <div>{{item.totalScore ? item.totalScore : '/'}}</div>
              <div>{{item.ranking ? item.ranking : '/'}}</div>
              <div>{{item.oralTest ? item.oralTest : '/'}}</div>
              <div>{{item.remarks ? item.remarks : '/'}}</div>
            </div>
          </div>
          <div class="base-tr title-th"><div class="txt-l">升学通道</div></div>
          <div class="base-tr">
            <div>
              <div class="txt-l checked-section" v-for="(item, index) in channelsFirstData" :key="index">
                <div class="checked-box" :class="{'checked-box-active': item.value}" style="width: 100%;">
                  <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                  <div v-else class="inner-box" ></div>
                  <span>{{item.label}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="txt-l checked-section" v-for="(item, index) in channelsSecondData" :key="index">
                <div class="checked-box" :class="{'checked-box-active': item.value}" style="width: 100%;">
                  <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                  <div v-else class="inner-box" ></div>
                  <span>{{item.label}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="txt-l checked-section" v-for="(item, index) in channelsThirdData" :key="index">
                <div class="checked-box" :class="{'checked-box-active': item.value}" style="width: 100%;">
                  <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                  <div v-else class="inner-box" ></div>
                  <span>{{item.label}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="txt-l checked-section" v-for="(item, index) in channelsForthData" :key="index">
                <div class="checked-box" :class="{'checked-box-active': item.value}" style="width: 100%;">
                  <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                  <div v-else class="inner-box" ></div>
                  <span>{{item.label}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="base-tr">
            <div class="remark-box">{{ neweditForm.remarks }}</div>
          </div>
          <div class="base-tr title-th" style="border-bottom: 0;"><div class="txt-l">报考意向</div></div>
          <div class="base-tr" v-if="neweditForm.examMsg">
            <div class="intention-apply-tr" >
              <div class="apply-left" >方案倾向</div>
              <div class="apply-right" >
                <div class="b-r-l p-0-10 txt-l checked-section">
                  <div class="checked-box" v-for="(item, index) in neweditForm.examMsg.scheme" :key="index" :class="{'checked-box-active': item.value}">
                    <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                    <div v-else class="inner-box" ></div>
                    <span>{{item.label}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="base-tr" v-if="neweditForm.examMsg">
            <div class="intention-apply-tr" >
              <div class="apply-left" >大学规划</div>
              <div class="apply-right" >
                <div class="b-r-l p-0-10 txt-l checked-section">
                  <div class="checked-box" v-for="(item, index) in neweditForm.examMsg.universityPlanning" :key="index" :class="{'checked-box-active': item.value}">
                    <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                    <div v-else class="inner-box" ></div>
                    <span>{{item.label}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="base-tr" v-if="neweditForm.examMsg">
            <div class="intention-apply-tr" >
              <div class="apply-left" >合作办学</div>
              <div class="apply-right" >
                <div class="b-r-l p-0-10 txt-l checked-section">
                  <div class="checked-box" v-for="(item, index) in neweditForm.examMsg.cooperativeSchool" :key="index" :class="{'checked-box-active': item.value}">
                    <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                    <div v-else class="inner-box" ></div>
                    <span>{{item.label}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="base-tr">
            <div class="intention-apply-tr" v-if="neweditForm.examMsg">
              <div class="apply-left" >志愿意向</div>
              <div class="apply-right" >
                <div class="child-box">
                  <div class="child-left" >意向学校</div>
                  <div class="child-right txt-l" >{{neweditForm.examMsg.intentionApply.schoolName ? neweditForm.examMsg.intentionApply.schoolName : '/'}}</div>
                </div>
                <div class="child-box">
                  <div class="child-left" >意向专业</div>
                  <div class="child-right txt-l" >{{neweditForm.examMsg.intentionApply.professionName ? neweditForm.examMsg.intentionApply.professionName : '/'}}</div>
                </div>
                <div class="child-box">
                  <div class="child-left" >意向职业</div>
                  <div class="child-right txt-l" >{{neweditForm.examMsg.intentionApply.occupationName ? neweditForm.examMsg.intentionApply.occupationName : '/'}}</div>
                </div>
                <div class="child-box">
                  <div class="child-left" >意向城市</div>
                  <div class="child-right txt-l" >{{neweditForm.examMsg.intentionApply.cityName ? neweditForm.examMsg.intentionApply.cityName : '/'}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="base-tr title-th"><div class="txt-l">备注说明</div></div>
          <div class="base-tr">
            <div class="remark-box">{{neweditForm.others}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="right-btn-box">
    <el-button style="background-color: #1264ff;" circle v-print="'#baseData'" >打印</el-button>
    <el-button style="background-color: #7870b6;" circle @click="getPdf('#datas')">下载</el-button>
    <el-button style="background-color: #a4b0be;" circle @click="goBack()">上一级</el-button>
  </div>
</div>
</template>

<script>
import { request } from "@/util/request";
import qs from "qs"
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

// 科类
const MajorData = [
  {
    label: '物理类',
    value: 1
  },
  {
    label: '历史类',
    value: 2
  },
  {
    label: '物理',
    value: 3
  },
  {
    label: '历史',
    value: 4
  },
]
// 升学渠道
const ChannelsFirstData = [
  {
    label: '强基计划',
    value: false
  },
  {
    label: '综合评价',
    value: false
  },
  {
    label: '港、澳独立招生',
    value: false
  },
  {
    label: '飞行技术专业',
    value: false
  },
  {
    label: '高水平运动队',
    value: false
  },
  {
    label: '高校专项计划',
    value: false
  },
  {
    label: '空乘、民航空中安保',
    value: false
  }
];
const ChannelsSecondData = [
  {
    label: '军队院校',
    value: false
  },
  {
    label: '公安本科专业',
    value: false
  },
  {
    label: '中国消防救援学院',
    value: false
  },
  {
    label: '司法本科专业',
    value: false
  },
  {
    label: '定向培养军士',
    value: false
  },
  {
    label: '公安高职 (专科) 专业',
    value: false
  },
  {
    label: '免费医学定向生',
    value: false
  }
];
const ChannelsThirdData = [
  {
    label: '北京电子科技学院',
    value: false
  },
  {
    label: '公费师范生',
    value: false
  },
  {
    label: '优师专项',
    value: false
  },
  {
    label: '航海类专业',
    value: false
  },
  {
    label: '小语种',
    value: false
  },
  {
    label: '种子科学与工程',
    value: false
  },
  {
    label: '全国重点马克思主义学院',
    value: false
  }
];
const ChannelsForthData = [
  {
    label: '国家专项计划',
    value: false
  },
  {
    label: '地方专项计划',
    value: false
  },
  {
    label: '定向就业',
    value: false
  },
  {
    label: '民族班',
    value: false
  },
  {
    label: '少数民族预科班',
    value: false
  },
  {
    label: '四川大学预科班',
    value: false
  },
  {
    label: '边防军子女预科班',
    value: false
  },
];

export default {
  name: "previewArchives",
  data () {
    return {
      // 基本资料
      channelsFirstData: ChannelsFirstData,
      channelsSecondData: ChannelsSecondData,
      channelsThirdData: ChannelsThirdData,
      channelsForthData: ChannelsForthData,
      neweditForm: null,
      chooseMedical: [], // 体检结论
    }
  },
  filters: {
    filterMajor(value) {
      const major = MajorData.find((item) => item.value == value)
      return major.label
    },
  },
  methods: {
    // 基础信息表格内容获取
    baseInitializeFn () {
      const user = JSON.parse(sessionStorage.getItem('user'))
      this.userId = user.userId
      this.getStu()
    },
    // 获取学生信息
    getStu () {
      request({
        method: 'get',
        url: 'students/getStu',
        params: {
          Id: this.userId
        }
      }).then(res => {
        this.neweditForm = JSON.parse(localStorage.getItem('stu'))
        this.neweditForm = res.data
        this.stuId = this.neweditForm.id
        this.neweditForm.examMsg = JSON.parse(this.neweditForm.examMsg)
        this.getNotAdmitted()
        if (this.neweditForm.address && this.neweditForm.address.indexOf('undefined') > -1) {
          console.log('==学生档案==', this.neweditForm.address)
          this.neweditForm.address = ''
        }
        // console.log('==学生档案==', JSON.stringify(this.neweditForm))
      })
    },
    // 整理强基计划内容
    formatCheckMsg () {
      if (!this.neweditForm.checkMsg) {
        return
      }
      this.neweditForm.checkMsg.forEach(e => {
        this.channelsFirstData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
        this.channelsSecondData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
        this.channelsThirdData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
        this.channelsForthData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
      })
    },
    // 获取体检结论
    getNotAdmitted () {
      request({
        method: 'POST',
        url: 'stuArchivesRel/getNotAdmitted',
        params: {
          stuid: this.neweditForm.id
        }
      }).then(res => {
        let list = []
        res.data.xz.forEach(i => {
          list.push(i.code.toString())
        })
        this.chooseMedical = list
      })
    },
    // 下载pdf
    getPdf (url) {
      let title = this.neweditForm.name + "高考志愿填报档案表";
      html2Canvas(document.querySelector(url), {
        allowTaint: true,
        taintTest: false,
        logging: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 1.5, //将分辨率提高到特定的DPI 提高四倍
        // dpi:300,
        scale: 1.5 //按比例增加分辨率
      }).then(canvas => {
        var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向

        var ctx = canvas.getContext('2d'),
          a4w = 260, a4h = 280,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        while (renderedHeight < canvas.height) {
          var page = document.createElement("canvas");
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页

          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', -25, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) {
            pdf.addPage();//如果后面还有内容，添加一个空页
          }
        }
        //保存文件
        pdf.save(title + '.pdf')
      })
    },
    // 上一级
    goBack () {
      this.$router.go(-1);
    }
  },
  created () {
    this.baseInitializeFn()
  }
}
</script>

<style lang="stylus" scoped>
pageWidth = 1400px
$color-theme = #f96630
$color-table-border = #999

.preview-container
  position relative
  width: pageWidth;
  margin: 0 auto;
  font-size: 14px;

  div
    box-sizing: border-box;

  .m-l-20
    margin-left 20px

  .b-r-l
    border-left: 1px solid $color-table-border;
  .b-r-r
    border-right: 1px solid $color-table-border;
  .p-0-10
    padding: 0 10px;

  .right-btn-box
    position: fixed;
    top: 50%;
    margin-top: -120px;
    right: 10px;
    width: 60px;
</style>
<style scoped>
.preview-container {
  width: 1400px;
  margin: 0 auto;
  font-size: 14px;
}

.preview-container div {
  box-sizing: border-box;
}

.m-l-20 {
  margin-left: 20px
}

.m-t-20 {
  margin-top: 20px
}

.b-r-l {
  border-left: 1px solid #999;
}
.p-0-10 {
  padding: 0 10px;
}
.txt-l {
  text-align: left !important;
}

.right-btn-box  .el-button {
  width: 60px;
  height: 60px;
  padding: 0;
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
}
.right-btn-box  .el-button+.el-button {
  margin-left: 0;
}

.base-data {
  width: 1050px;
  margin: auto;
  padding: 0;
}
.base-data .base-title {
  width: 100%;
  margin-top: 50px;
  font-size: 25px;
  color: #333;
  font-weight: 600;
  text-align: center
}

.base-data .base-table {
  margin: 50px auto;
  border: 1px solid #999;
}
.base-data .base-tr, .base-tr-other {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #999;
}
.base-data .base-tr:last-child {
  border-bottom: none
}
.base-data .base-tr > div {
  flex: 1;
  min-height: 33px;
  line-height: 33px;
  padding: 0 10px;
  text-align: center;
  border-right: 1px solid #999
}
.base-data .base-tr > div:last-child {
  border-right: none
}
.base-data .base-tr-other > div {
  width: 10%;
  min-height: 33px;
  line-height: 33px;
  padding: 0 10px;
  text-align: center;
  border-right: 1px solid #999
}
.base-data .base-tr-other > div:nth-child(2n-1) {
  font-weight: 600;
}
.base-data .base-tr-other > div:last-child {
  border-right: none;
}
.base-data .title-th {
  font-size: 16px;
  font-weight: 600;
}
.base-data .remark-box {
  min-height: 60px !important;
  text-align: left !important;
}
.base-data .base-tr-other .w-10 {
  width: 10%;
  padding: 0 !important;
}
.base-data .base-tr-other .w-20 {
  width: 20%;
  padding: 0 !important;
}
.base-data .base-tr .flex-2 {
  flex: 2;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
}
.base-data .base-tr .flex-4 {
  flex: 4;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
}
.base-data .base-tr .flex-8 {
  flex: 8;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
  display: flex;
  align-items: center;
}
.base-data .base-tr .flex-8 > div {
  flex: 1;
  min-height: 33px;
  text-align: center;
  border-right: 1px solid #999
}
.base-data .base-tr .flex-8 > div:last-child {
  border-right: none
}
.base-data .base-tr .intention-apply-tr {
  display: flex;
  align-items: center;
  padding: 0 !important;
}
.base-data .apply-left {
  flex: 1;
}
.base-data .apply-right {
  flex: 9;
}
.base-data .apply-right .el-checkbox {
  width: 80px;
}
.base-data .checked-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.base-data .checked-section .checked-box {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.base-data .checked-section .checked-box-active {
  color: #f96630;
}
.base-data .checked-section .checked-box .inner-box {
  position: relative;
  margin-right: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
}
.base-data .checked-section .checked-box .inner-box-active {
  position: relative;
  margin-right: 10px;
  border: 1px solid #f96630;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
}
.base-data .child-box {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #999;
}
.base-data .child-box:last-child {
  border-bottom: none;
}
.base-data .child-left {
  flex: 1.5;
  padding: 0 10px;
  border-left: 1px solid #999;
  border-right: 1px solid #999;
}
.base-data .child-right {
  flex: 8.5;
  padding: 0 10px;
}
.base-data .score-tr div {
  flex: 0.7;
}


</style>
